import React from "react";

function SvgHomeIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      color="currentColor"
    >
      <defs>
        <clipPath id="clip-Home_feed_2_1">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g
        id="Home_feed_2_1"
        data-name="Home/feed 2 – 1"
        clipPath="url(#clip-Home_feed_2_1)"
      >
        <path
          id="home"
          d="M48.656,21.748l0,0-20.4-20.4a4.6,4.6,0,0,0-6.51,0L1.357,21.733l-.021.021A4.6,4.6,0,0,0,4.4,29.6q.07.007.142.007h.813v15.01A5.393,5.393,0,0,0,10.743,50h7.98a1.465,1.465,0,0,0,1.465-1.465V36.768a2.461,2.461,0,0,1,2.458-2.458h4.707a2.461,2.461,0,0,1,2.458,2.458V48.535A1.465,1.465,0,0,0,31.276,50h7.98a5.393,5.393,0,0,0,5.388-5.387V29.6H45.4a4.6,4.6,0,0,0,3.258-7.856Zm0,0"
          transform="translate(0.001 0)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgHomeIconNew);
